var defaultSDKSettingsResponse = {
    appVersion: 'unknown',
    nativeSocialTypesEnabled: []
};

var defaultTransactionDataResponse = {
    transactionId: undefined,
    mfaOperationCode: undefined,
    currency: 'USD',
    amount: '0',
    statement: {
        date: '19 March 2025',
        time: '19:20'
    }
};

var PasskeyRegistrationExitState = /*#__PURE__*/ function(PasskeyRegistrationExitState) {
    PasskeyRegistrationExitState["PASSKEY_NOT_NOW"] = "PASSKEY_NOT_NOW";
    PasskeyRegistrationExitState["PASSKEY_BACK"] = "PASSKEY_BACK";
    PasskeyRegistrationExitState["PASSKEY_CREATED"] = "PASSKEY_CREATED";
    return PasskeyRegistrationExitState;
}({});

var OnLoginSuccessAction = /*#__PURE__*/ function(OnLoginSuccessAction) {
    OnLoginSuccessAction["DISMISS"] = "dismiss";
    OnLoginSuccessAction["NOTHING"] = "nothing";
    return OnLoginSuccessAction;
}({});

export { OnLoginSuccessAction, PasskeyRegistrationExitState, defaultSDKSettingsResponse, defaultTransactionDataResponse };
